import Container from 'app/components/base/Container'
import Divider from 'app/components/base/Divider'
import Stack from 'app/components/base/Stack'
import { useGetHelpCenterCategories } from 'app/services/Query/help-center/help-center.query'
import {
  HELP_CENTER_CATEGORY_PARAMS,
  HELP_CENTER_MAIN_CATEGORIES_PLACEHOLDER
} from 'app/utils/constants/help-center.constants'
import { getCategoryLink } from 'app/utils/helpers/help-center.helpers'

import HelpCenterCategoryCard from './components/HelpCenterCategoryCard'

const HelpCenterCategoriesFeature = () => {
  const { data: categories, isPlaceholderData } = useGetHelpCenterCategories({
    params: HELP_CENTER_CATEGORY_PARAMS,
    options: {
      enabled: false,
      placeholderData: HELP_CENTER_MAIN_CATEGORIES_PLACEHOLDER
    }
  })

  return (
    <Container
      maxWidth="md"
      sx={{
        px: 2,
        mt: { md: 10 },
        pb: 7
      }}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        sx={{ flexWrap: { xs: 'initial', md: 'wrap' } }}
      >
        {categories?.map((item, index) => {
          const itemNumber = index + 1
          const needDivider = itemNumber % 3 === 0
          const isLastItem = index === categories?.length - 1

          const showDivider = needDivider && !isLastItem
          const link = getCategoryLink(item.slug, item?.sub_categories)

          return (
            <>
              <HelpCenterCategoryCard
                key={item.id}
                link={link}
                name={item.name}
                icon={item.icon}
                iconAltText={item?.help_center_category_icon?.alt_text}
                needBorderRight={!needDivider}
                hideBorderBottom={isLastItem}
                isLoading={isPlaceholderData}
              />

              {showDivider && (
                <Divider
                  sx={{ flex: '100%', display: { xs: 'none', md: 'flex' } }}
                />
              )}
            </>
          )
        })}
      </Stack>
    </Container>
  )
}

export default HelpCenterCategoriesFeature
